export default function getGeneralReportInstitution(response) {
  const data = response?.data?.response?.elements?.map((item) => {
    return {
      fullName: item.fullName,
      roleName: item.roleName,
      queryQuantity: item.queryQuantity,
      totalValue: item.totalValue,
    };
  });

  return { ...response?.data?.response, list: data };
}
